import Aksharamukha from './aksharamukha';
export default Aksharamukha;
export * from './aksharamukha';